export default "__VITE_ASSET__CYDwQrro__"